export const profilePagesPaths = {
    userArea: '/account/preferences/',
};

// TODO: For monitoring purposes we are maintaining this mapping of profile pages. Once rolled out, we can define the correct one.
export const profilePagesMap = {
    '/account/preferences/': 'account_preferences',
};
